export const SITE_ORIGIN = 'https://vsevsetaksi.ru'
export const SITE_NAME = 'ABG Taxi'
export const LEGAL_NAME = 'ООО «АБ ГРУПП»'

export const FLEET_URL = 'https://forms.fleet.yandex.ru/forms?ref_id=66a186f97c454251848574b8fae33919&lang=ru'
// General delivery forms, not the separate Edaru payout advertising cohort.
export const DELIVERY_SMZ_URL = 'https://forms.fleet.yandex.ru/forms?ref_id=9c78b081939542349eac4f59de081f98'
export const DELIVERY_WITHOUT_SMZ_URL = 'https://forms.fleet.yandex.ru/forms?ref_id=372f677d0cd14459b3de3c9f1200c3b7'
export const EDA_URL = 'https://yaeda.tb.ru/'
export const EDARU_URL = 'https://edaru.su'

export const CONTACTS = {
  max: 'https://max.ru/u/f9LHodD0cOLswOkn7RjlfSg1_5fQcqGNApIS1M82XvxCIhFlKEb62UKWGLU',
  phoneDisplay: '+7 (911) 288-43-44',
  phoneHref: 'tel:+79112884344',
  whatsapp: 'https://wa.me/79112884344',
  telegram: 'https://t.me/abgroupp_bot',
  telegramChannel: 'https://t.me/abg_taxi_group',
  vk: 'https://vk.com/abgtaxi',
  youtube: 'https://www.youtube.com/@vdvige',
}

export const COMPANY = {
  name: LEGAL_NAME,
  inn: '7805757269',
  kpp: '780501001',
  ogrn: '1197847201970',
  address: '198095, Санкт-Петербург, ул. Ивана Черных, д. 20, литера А, помещ. 101',
}
